import { useQuery } from '@tanstack/react-query';
import { api, podatki, type Shema } from '../api/odjemalec';
import { kolicina } from '../oblika/oblika';

export type KompletGum = Shema['KompletGum'];
export type SezonaGum = NonNullable<KompletGum['sezona']>;
export type PlatiscaGum = NonNullable<KompletGum['platisca']>;
export type StanjeGum = NonNullable<KompletGum['stanje']>;

/** Sezone kompleta gum (kot SezonaGum na strežniku) z barvo značke. */
export const SEZONE: Record<SezonaGum, { naziv: string; barva: string }> = {
  LETNE: { naziv: 'Letne', barva: 'yellow' },
  ZIMSKE: { naziv: 'Zimske', barva: 'blue' },
  CELOLETNE: { naziv: 'Celoletne', barva: 'teal' },
};

export const PLATISCA: { value: PlatiscaGum; label: string }[] = [
  { value: 'BREZ', label: 'Brez platišč' },
  { value: 'JEKLENA', label: 'Jeklena platišča' },
  { value: 'ALU', label: 'Alu platišča' },
];

export const STANJA_GUM: Record<StanjeGum, string> = { SHRANJEN: 'V hotelu', PREVZET: 'Prevzete' };

/** Gume v eni vrstici: »185/65 R15 · Michelin Primacy 4 88H«. */
export function opisGum(g: KompletGum | undefined | null): string {
  if (!g) {
    return '';
  }
  return [g.dimenzija, [g.znamka, g.vzorec, g.indeks].filter(Boolean).join(' ')].filter(Boolean).join(' · ');
}

/** Najmanjši profil: »4,2 mm« (prazno brez meritve). */
export function profil(mm: number | undefined | null): string {
  return mm == null ? '' : `${kolicina(mm)} mm`;
}

/** Cenik hotela za gume (zaslon Cenik in izbira postavke v kompletu). */
export function useCenikHotelaGum() {
  return useQuery({
    queryKey: ['cenik-hotela-gum'],
    queryFn: ({ signal }) => podatki(api.GET('/api/delavnica/gume/cenik', { signal })),
  });
}
